import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayNowService {

  // == ACTIONS =======================================================

  msClient = new BehaviorSubject<string>(null);
  msClient$ = this.msClient.asObservable();

  setMSClient(msClient: string){
    return this.msClient.next(msClient);
  }
}
